export const buildSseUrl = (baseUrl, token) =>
  `${baseUrl}/api/events?token=${encodeURIComponent(token)}`;
